/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pTokenFrom.vue?vue&type=template&id=46cfb896"
import script from "./pTokenFrom.vue?vue&type=script&lang=js"
export * from "./pTokenFrom.vue?vue&type=script&lang=js"
import style0 from "./pTokenFrom.vue?vue&type=style&index=0&id=46cfb896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports